export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topbar-start.vue?vue&type=template&id=79499723"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/topbar/topbar-start.vue?vue&type=template&id=79499723
// module id = uYzk
// module chunks = 0